import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from 'vue';
import * as amplitude from '@amplitude/analytics-browser';
import { getQueryParams } from './helpers';

// Use onMounted to track the page view when the component is mounted

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(() => {
  const queryParams = getQueryParams();
  const currentUrl = window.location.href;

  // Exclude URLs that contain "admin-dashboard"
  if (!currentUrl.includes('admin-dashboard')) {
    amplitude.track('page_view', {
      ...queryParams,
      url: currentUrl,
    });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})